import React, { useState } from 'react';
import classNames from 'classnames';
import './styles.scss';

const PlaceholderImage = ({ src, alt, className }) => {
  const [isLoaded, setLoaded] = useState(false);

  return (
    <>
      <img
        onLoad={() => setLoaded(true)}
        src={src}
        alt={alt}
        className={className}
        style={{ display: isLoaded ? 'block' : 'none' }}
      />
      <div
        className={classNames('courses-placeholder-image', 'placeholder-glow', className)}
        style={{ display: isLoaded ? 'none' : 'block' }}
      >
        <div className="placeholder" />
      </div>
    </>
  );
};

export default PlaceholderImage;
